
import axiosInstance from "../auth/axioInstance";

export function getBanner() {
    return axiosInstance.get("banner");
}

export function updateBanner(formdata) {
    return axiosInstance.post(`banner/addorupdatebanner`, formdata, { headers: { 'Content-Type': "multipart/form-data"} });
}